const SESSION_KEY = "consent_link_session";

export interface PersistedConsentSession {
    scoped_token: string;
    consent_id: string;
    allowed_scopes: string[];
    expires_at: string;
}

export function persistConsentSession(session: PersistedConsentSession): void {
    try {
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
    } catch {
        // sessionStorage unavailable — session won't survive refresh
    }
}

export function loadPersistedConsentSession(): PersistedConsentSession | null {
    try {
        const raw = sessionStorage.getItem(SESSION_KEY);
        if (!raw) return null;
        const data: PersistedConsentSession = JSON.parse(raw);
        if (new Date(data.expires_at) <= new Date()) {
            sessionStorage.removeItem(SESSION_KEY);
            return null;
        }
        return data;
    } catch {
        return null;
    }
}

export function clearPersistedConsentSession(): void {
    sessionStorage.removeItem(SESSION_KEY);
}
